import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import audiowave from "../../../assets/img/audio_wave.svg";
import logo from "../../../assets/img/logo.svg";
import wave from "../../../assets/img/sound-wave-icon.svg";
import "./home.css";
const Home = () => {
  const navigate = useNavigate();
  const { token } = useParams();
  const handleClickStartInterview = () => {
    navigate(`/meeting/${token}/setup`);
  };

  return (
    <div className="container-fluid px-0 ">
      <nav className="navbar bg-white py-4 ">
        <div className="container">
          <a className="navbar-brand mx-auto" href="#">
            <img src={logo} alt="" />
          </a>
        </div>
      </nav>
      <div className="container main-container">
        <div className=" p-4">
          <h1 className="interview-heading">Hey John! Welcome</h1>
          <p className="interview-text-primary">
            This is the interview portal for your interview. You will have a
            series of questions to which you can answer by either typing or
            speaking. Click start Interview when you're ready.
          </p>
        </div>
        <div className="how-it-work-container">
         
         <div className="d-flex justify-content-center mt-4">
            <button
              className="btn btn-primary-interview"
              onClick={handleClickStartInterview}
            >
              Continue
          </button>
        </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
